import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { FreewheelConstants } from 'tag/ts/tag/model/FreewheelConstants';
import { AdUtilities } from 'tag/ts/tag/utilities/AdUtilities';
export class HTML5AdParameterBuilder extends AbstractTagClass {
    #adUtilities;
    #constants;
    #CONTEXT;
    #argument;
    constructor(argument) {
        super({
            ...argument,
            name: 'HTML5AdParameterBuilder'
        });
        this.#adUtilities = new AdUtilities({ tag: argument.tag });
        this.#CONTEXT = argument?.tag?.params?.AD?.CONTEXT;
        this.#constants = FreewheelConstants.getInstance();
        this.#argument = argument;
    }
    buildAdParameters = () => {
        let adParameters = {};
        if (!this.#adUtilities.paramsContainsAdContext()) {
            this?.logger?.log('createAdParameters', 'No HTML5 ad info found');
            return adParameters;
        }
        adParameters = this.#setFreewheelData(adParameters);
        adParameters = this.#setIntlAdTierData(adParameters);
        adParameters = this.#setOtherAdParams(adParameters);
        this?.logger?.log('createAdParameters', 'HTML5 ad info found:', adParameters);
        return adParameters;
    };
    #setFreewheelData(adParameters) {
        const CONTEXT = this.#CONTEXT;
        const { queryParams, playerSpecificData, isIntl, frequencyManagement, packageSource, fwIdPlatformType, userType, isKids, mediaType, isLAT, fw_deviceid, isContinuousPlay, subsLifeStageIndicator } = CONTEXT;
        const testParams = playerSpecificData;
        const tfcdVal = queryParams?.tfcd;
        const nextShowsParam = testParams?.nextShowsIdsArray?.length
            ? `recommended_show=${testParams.nextShowsIdsArray
                .slice(0, 10)
                .join(',')}`
            : '';
        const bundleParam = testParams?.bundle
            ? `bundle=${testParams.bundle}`
            : '';
        const includeAmpersand = testParams?.bundle && testParams?.nextShowsIdsArray?.length ? '&' : '';
        const includeCustParams = !!(testParams?.bundle || testParams?.nextShowsIdsArray?.length);
        const isAnonUser = userType === 'ANON';
        const FREE_CONTENT_HUB = 'free-content-hub';
        adParameters = {
            ...adParameters,
            ...(mediaType !== 'Live' && {
                imafw__fw_continuous_play: isContinuousPlay ? '1' : '0',
                imafw__fw_coppa: tfcdVal
            }),
            imafw_tfcd: tfcdVal,
            tfcd: tfcdVal,
            imafw__fw_is_lat: isLAT,
            imafw_is_lat: isLAT,
            is_lat: isLAT,
            rdid: tfcdVal === '0' ? fw_deviceid : null,
            imafw_idtype: `${fwIdPlatformType}`,
            imafw__fw_vcid2: CONTEXT?.imafw__fw_vcid2,
            imafw_packageSource: packageSource,
            ...(!isKids && { imafw_sub: testParams?.sub?.toString() }),
            imafw_sb: testParams?.sb,
            imafw_tsb: testParams?.tsb,
            imafw_vguid: testParams?.vguid,
            imafw_session: testParams?.session,
            imafw_subses: testParams?.subses?.toString(),
            imafw_user: testParams?.user,
            imafw_sz: this.#constants?.size,
            ...(testParams?.section === FREE_CONTENT_HUB && {
                imafw_section: FREE_CONTENT_HUB
            }),
            ...(includeCustParams && {
                cust_params: `${bundleParam}${includeAmpersand}${nextShowsParam}`
            }),
            ...playerSpecificData,
            streamingUrl: this.#argument?.tag?.params?.CONTENT?.resource?.location?.mediaUrl,
            ...(isAnonUser && {
                imafw_sb: '0',
                imafw_section: FREE_CONTENT_HUB
            }),
            ...(subsLifeStageIndicator && { imafw_sublife: subsLifeStageIndicator }),
            imafw_cadence: CONTEXT.billingCadence,
            imafw_packageType: CONTEXT.packageSourceType,
            imafw_profile: CONTEXT.activeProfileId,
            ...(!isIntl && !isKids && {
                imafw_ge: testParams?.ge?.toString(),
                imafw_gr: testParams?.gr?.toString()
            }),
            ...frequencyManagement,
            imafw__fw_us_privacy: CONTEXT?.imafw__fw_us_privacy,
            imafw__fw_gdpr: CONTEXT?.imafw__fw_gdpr,
            imafw__fw_gdpr_consent: CONTEXT?.imafw__fw_gdpr_consent,
            imafw_gpp: CONTEXT?.imafw_gpp,
            imafw_gpp_sid: CONTEXT?.imafw_gpp_sid,
            imafw__fw_3P_UID: CONTEXT?.imafw__fw_3P_UID,
            imafw_fms_bididtype: CONTEXT?.imafw_fms_bididtype,
            imafw_fms_emailhash: CONTEXT?.imafw_fms_emailhash,
            imafw_fms_hh_ramp_id: CONTEXT?.imafw_fms_hh_ramp_id,
            imafw_fms_ifa: CONTEXT?.imafw_fms_ifa,
            imafw_fms_ramp_id: CONTEXT?.imafw_fms_ramp_id,
            imafw_fms_ruleid: CONTEXT?.imafw_fms_ruleid,
            imafw_fms_subscriberid: CONTEXT?.imafw_fms_subscriberid,
            imafw_fms_vcid2type: CONTEXT?.imafw_fms_vcid2type,
            imafw_fms_userid: CONTEXT?.imafw_fms_userid,
            imafw_fms_connectid: CONTEXT?.imafw_fms_connectid,
            imafw_fms_ramp_envelope: CONTEXT?.imafw_fms_ramp_envelope,
            imafw_fms_uid2: CONTEXT?.imafw_fms_uid2
        };
        return adParameters;
    }
    #setIntlAdTierData(adParameters) {
        const adUtilities = this.#adUtilities;
        const { frequencyManagement, regionalLanguage, clientRegion, audioLanguage, pageType, showSectionTitle, movieSectionTitle, endCardSourceType, hubSlug, rowHeaderTitle } = this.#CONTEXT;
        const locatorAdParams = {
            imafw_ptype: adUtilities?.formatAdParameter(pageType),
            imafw_showSection: adUtilities?.formatAdParameter(showSectionTitle),
            imafw_movieSection: adUtilities?.formatAdParameter(movieSectionTitle),
            ...(regionalLanguage && {
                imafw_language_selection: audioLanguage,
                imafw__fw_h_x_country: clientRegion,
                imafw_device_region_language: regionalLanguage,
                imafw__fw_content_language: regionalLanguage
            }),
            ...(endCardSourceType ?
                {
                    imafw_endcard: true,
                    imafw_source: adUtilities?.formatAdParameter(endCardSourceType)
                } :
                {
                    imafw_source: adUtilities?.formatAdParameter(hubSlug
                        ? hubSlug
                        : rowHeaderTitle)
                })
        };
        adParameters = {
            ...adParameters,
            ...locatorAdParams,
            ...(regionalLanguage && {
                imafw__fw_content_language: regionalLanguage,
                imafw_language_selection: audioLanguage,
                imafw_device_region_language: regionalLanguage,
                imafw__fw_h_x_country: clientRegion
            }),
            imafw_region: clientRegion,
            ...frequencyManagement
        };
        return adParameters;
    }
    #setOtherAdParams(adParameters) {
        const { mediaType, useSSBForLTS } = this.#CONTEXT;
        if (mediaType === 'Live') {
            [
                'imafw__fw_continuous_play',
                'imafw__fw_coppa',
                'imafw_cpPre',
                'imafw_cpSession'
            ].forEach((param) => delete adParameters[param]);
        }
        if (useSSBForLTS) {
            [
                'sb',
                'ge',
                'gr',
                'sub',
                'bundle',
                'session',
                'subses',
                'user',
                'vguid',
                'streamingUrl',
                'imafw__fw_continuous_play'
            ].forEach((param) => delete adParameters[param]);
        }
        return adParameters;
    }
}
